export { AnimateOnScroll } from "./AnimateOnScroll";
export { Button } from "./Button";
export { FadeIn } from "./FadeIn";
export { CTA } from "./CTA";
export { DashboardPreview } from "./DashboardPreview";
export { Features } from "./Features";
export { Footer } from "./Footer";
export { Hero } from "./Hero";
export { InstallBanner } from "./InstallBanner";
export { Logo, LogoSmall } from "./Logo";
export { LogoBar } from "./LogoBar";
export { Navbar } from "./Navbar";
export { Pricing } from "./Pricing";
export { Principles } from "./Principles";
export { StaggeredList } from "./StaggeredList";
export { UIPreview } from "./UIPreview";

// Admin components
export { AdminLayoutClient } from "./admin/AdminLayoutClient";
export { AuthGuard } from "./admin/AuthGuard";
export { DeleteConfirmDialog } from "./admin/DeleteConfirmDialog";
export { LogoutButton } from "./admin/LogoutButton";
export { PostForm } from "./admin/PostForm";
export { PostList } from "./admin/PostList";
export { TagMultiSelect } from "./admin/TagMultiSelect";
export { TiptapEditor } from "./admin/TiptapEditor";
export { Skeleton, PostListSkeleton, PostFormSkeleton } from "./admin/Skeleton";

// NOTE: Tiptap extensions are NOT exported here to avoid client-side code
// being evaluated in Server Components. Import them directly from
// "./admin/tiptap-extensions" in client components that need them.

// Demo components
export { ArtifactsTab } from "./demo/ArtifactsTab";
export { ChangesTab } from "./demo/ChangesTab";
export { DemoShell } from "./demo/DemoShell";
export { IssuesTab } from "./demo/IssuesTab";
export { ProjectList } from "./demo/ProjectList";
export { SpecView } from "./demo/SpecView";

// Viewer components
export { AnnotationPanel } from "./demo/viewer/AnnotationPanel";
export {
  clearAllAnnotations,
  demoAnnotations,
  loadAnnotations,
  saveAnnotations,
} from "./demo/viewer/annotationStorage";
export { AnnotationToolbar } from "./demo/viewer/AnnotationToolbar";
export { ArtifactEditor } from "./demo/viewer/ArtifactEditor";
export { MarkdownRenderer } from "./demo/viewer/MarkdownRenderer";
export type {
  Block,
  SelectionInfo,
  ViewerAnnotation,
} from "./demo/viewer/types";
export { UnsavedChangesDialog } from "./demo/viewer/UnsavedChangesDialog";

// Blog components
export { BlogCard } from "./blog/BlogCard";
export { BlogContentRenderer } from "./blog/BlogContentRenderer";
export { BlogDetailSkeleton } from "./blog/BlogDetailSkeleton";
export { BlogGrid } from "./blog/BlogGrid";
export { BlogHero } from "./blog/BlogHero";
export { BlogListSkeleton, BlogCardSkeleton } from "./blog/BlogListSkeleton";
export { BlogSearch } from "./blog/BlogSearch";
export { EmptyBlogState } from "./blog/EmptyBlogState";
export { EmptyState } from "./blog/EmptyState";
export { TableOfContents } from "./blog/TableOfContents";
export { TopicFilter } from "./blog/TopicFilter";

// CLI components
export { CodeBlock, InlineCode } from "./cli/CodeBlock";
export { DocsBreadcrumb } from "./cli/DocsBreadcrumb";
export { DocsLayout } from "./cli/DocsLayout";
export { DocsSidebar } from "./cli/DocsSidebar";
export { DocsTableOfContents } from "./cli/DocsTableOfContents";
export type { DocsSidebarItem } from "./cli/DocsSidebar";
export type { TocItem } from "./cli/DocsTableOfContents";
export type { BreadcrumbItem } from "./cli/DocsBreadcrumb";
